export default __webpack_public_path__ + "static/media/29_2_1.212e2346.png";